// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jzfQ","newExpiryDate":"styles_newExpiryDate__3TcxX","footer":"styles_footer__36Wmi"};